<template>
  <div>
    <ul class="menu">
      <li class="menu-item animated" v-for="(item, index) in data"
          @tap="menuClick(item,index)">
        <span>{{item.name}}<img class="m-l-5" :class="{'rotate180':isUnfold(index)}" v-show="item.children"
                                src="../../assets/img/header/arrow.png"></span>
        <ul v-if="item.children" class="nav-item-container">
          <nav-item-mobile ref="navItem" v-for="(citem, cindex) in item.children" :key="cindex" :data="citem"
                           :index="cindex" :show="isUnfold(index)" :layer="1"></nav-item-mobile>
        </ul>
      </li>
    </ul>
    <div class="lang-switch-mobile" @click="switchLang">
      <span class="lang-text">中</span>
      <span class="lang-divider">/</span>
      <span class="lang-text active-lang">EN</span>
    </div>
  </div>
</template>

<script>
  import NavItemMobile from "./NavItemMobile";

  export default {
    name: "NavMenuMobile",
    components: {NavItemMobile},
    props: {
      data: Array,
    },
    created() {
      const layerTotal = this.loop(this.data);
      const stateArr = [];
      for (let i = 0; i < layerTotal; i++) {
        stateArr.push(-1);
      }
      this.$store.state.navState = stateArr;
    },
    data() {
      return {
        layer: 0
      }
    },
    computed: {
      isUnfold() {
        return (index) => {
          return this.$store.state.navState[this.layer] === index;
        }
      },
    },
    methods: {
      switchLang() {
        this.$store.commit('foldNav');
        window.open('https://www.xktech.com', '_blank');
      },
      loop(children) {
        let layerTotal = 0;
        if (children.length > 0) {
          layerTotal++;
        }
        const childrenLayerArr = [];
        children.forEach((item) => {
          if (item.children) {
            childrenLayerArr.push(this.loop(item.children));
          }
        });
        if (childrenLayerArr.length > 0) {
          layerTotal += Math.max.apply(null, childrenLayerArr);
        }
        return layerTotal;
      },
      menuClick(route, index) {
        const currentIndex = this.$store.state.navState[this.layer];
        if (currentIndex == index) {
          this.$store.commit('updateNavState', {index: this.layer, value: -1});
        } else {
          this.$store.commit('updateNavState', {index: this.layer, value: index});
        }
        if (route.path) {
          if (this.$router.currentRoute.path !== route.path) {
            this.$store.commit('foldNav');
            if (route.path.indexOf("http") != -1 )
              window.open(route.path, "_blank");
            else
              this.$router.push({path: route.path});
          }
        }
      },
    }
  }

</script>

<style>
  .mobile-box .menu {
    cursor: pointer;
    text-align: left;
    padding: 0 20px;
    background: #eb580e;
    font-size: 15px;

  }

  .mobile-box .menu .menu-item {
    border-top: 1px ridge rgba(255, 255, 255, .3);
    line-height: 45px;
    color: #f2f2f2;
    position: relative;
  }

  .mobile-box .menu .menu-item span {
    display: block;
    width: 100%;
  }

  .mobile-box .menu .menu-item > span > img {
    position: absolute;
    right: 0px;
    top: 20px;
  }

  .mobile-box .nav-item-container {
    overflow: hidden;
  }

  .rotate180 {
    transform: rotate(180deg);
    transition: transform .3s ease;
    opacity: 1;
    display: block;
  }

  .lang-switch-mobile {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eb580e;
    padding: 14px 20px;
    cursor: pointer;
    font-size: 16px;
    color: rgba(242, 242, 242, 0.7);
    letter-spacing: 1px;
    user-select: none;
    border-top: 1px ridge rgba(255, 255, 255, .3);
  }

  .lang-switch-mobile .lang-divider {
    margin: 0 4px;
    color: rgba(242, 242, 242, 0.35);
  }

  .lang-switch-mobile .lang-text {
    transition: color 0.2s ease;
  }

  .lang-switch-mobile .lang-text.active-lang {
    color: #f2f2f2;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/NavMenuMobile/NavMenuMobile.vue